import Vue from "vue";
import { ServerTable } from "vue-tables-2";
import store from "../store";

// noinspection JSCheckFunctionSignatures
Vue.use(
  ServerTable,
  {
    sortIcon: {
      base: "fa-svg fa-svg-sort-alt-light",
      up: "fa-svg fa-svg-sort-alpha-up-light",
      down: "fa-svg fa-svg-sort-alpha-down-alt-light",
    },
    skin: "table table-striped table-bordered table-hover",
    perPage: 15,
    perPageValues: [15, 30, 50, 100],
    debounce: 800,
    texts: {
      count: "Showing {from} to {to} of {count} records|{count} records|One record",
      filter: "",
      filterPlaceholder: "Search",
      limit: "",
      page: "Page:",
      noResults: "No matching results",
      filterBy: "Filter by {column}",
      loading: "Loading...",
      defaultOption: "Select {column}",
      columns: "Columns",
    },
    requestKeys: {
      query: "search",
      limit: "limit",
      orderBy: "orderBy",
      ascending: "ascending",
      page: "page",
      byColumn: "byColumn",
    },
    responseAdapter: (response) => ({
      data: response.data,
      count: response.total,
    }),
    requestFunction(data) {
      const config = data;
      config.sortedBy = config.ascending === 1 ? "asc" : "desc";

      if (!config.orderBy) {
        delete config.orderBy;
      }

      if (this.options.advancedFilter && this.options.advancedFilter === true) {
        config.from = store.state["advanced-filter"].from;
        config.to = store.state["advanced-filter"].to;
        config.selectFilters = store.state["advanced-filter"].selectFilters;
      }

      return this.$http.get(this.url, { params: config }).then(
        (response) => response.json(),
        (error) => {
          this.dispatch("error", error);
        }
      );
    },
  },
  false,
  "bootstrap4"
);
